"use strict";

exports.wrapPageElement = require("./wrap-page");

exports.shouldUpdateScroll = function () {
  return false;
};